import { Calendar, Globe, MapPin } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import AppDateInput from '../../../components/AppDateInput'
import {
  SearchableSelect,
  SegmentedControl,
  useCartesAccesLabels,
} from '../shared'
import { nomadSearchFormShell } from '../../shared/NomadSearchHero'
import {
  moteurDateTriggerClass,
  moteurLabelClass,
} from '../../shared/moteurRechercheFormTheme'
import { useDestinations } from './useDestinations'

const FilterLabel = ({ icon: Icon, children }) => (
  <span className={`${moteurLabelClass} inline-flex items-center gap-1.5`}>
    <Icon className="h-3.5 w-3.5 text-[var(--color-primary-700)]" aria-hidden />
    {children}
  </span>
)

const SearchFilters = ({ filters, onChange, onChangeMany, hideTypeFilter = false, embedded = false }) => {
  const { t } = useTranslation()
  const { cardTypeOptions } = useCartesAccesLabels()
  const { countryOptions, cityOptions } = useDestinations(filters.country || undefined)

  const typeSegments = [{ value: 'all', label: t('cartesAcces.common.all') }, ...cardTypeOptions]
  const countries = [{ value: 'all', label: t('cartesAcces.recherche.filters.allCountries') }, ...countryOptions]
  const cities = [{ value: '', label: t('cartesAcces.recherche.filters.allCities') }, ...cityOptions]

  const shellClass = embedded
    ? nomadSearchFormShell
    : 'sticky top-0 z-30 -mx-6 mb-6 border-b border-[var(--border)] bg-[color-mix(in_oklab,var(--card)_95%,transparent)] px-6 py-4 pb-6 shadow-sm backdrop-blur'

  return (
    <div className={shellClass}>
      <div className="relative z-10 flex flex-wrap items-end gap-3">
        <div className="w-[200px]">
          <FilterLabel icon={Globe}>{t('cartesAcces.recherche.filters.country')}</FilterLabel>
          <SearchableSelect
            options={countries}
            value={filters.country || 'all'}
            onChange={(v) => onChangeMany({ country: v === 'all' ? '' : v || '', city: '' })}
            placeholder={t('cartesAcces.recherche.filters.allCountries')}
            aria-label={t('cartesAcces.recherche.filters.country')}
            controlSize="moteur"
          />
        </div>
        <div className="w-[200px]">
          <FilterLabel icon={MapPin}>{t('cartesAcces.recherche.filters.city')}</FilterLabel>
          <SearchableSelect
            options={cities}
            value={filters.city}
            onChange={(v) => onChange('city', v || '')}
            placeholder={t('cartesAcces.recherche.filters.allCities')}
            aria-label={t('cartesAcces.recherche.filters.city')}
            controlSize="moteur"
          />
        </div>
        <div className="w-[200px]">
          <AppDateInput
            id="cartes-search-date"
            name="date"
            label={t('cartesAcces.recherche.filters.date')}
            placeholder={t('cartesAcces.recherche.filters.ariaDate')}
            value={filters.date || ''}
            onChange={(v) => onChange('date', v || '')}
            compact
            labelClass={moteurLabelClass}
            triggerClassName={moteurDateTriggerClass}
          />
        </div>
        {!hideTypeFilter ? (
          <div className="ml-auto">
            <FilterLabel icon={Calendar}>{t('cartesAcces.recherche.filters.type')}</FilterLabel>
            <SegmentedControl
              options={typeSegments}
              value={filters.type || 'all'}
              onChange={(v) => onChange('type', v)}
              ariaLabel={t('cartesAcces.recherche.filters.ariaType')}
            />
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default SearchFilters
